import { render, staticRenderFns } from "./traineeQuestions.vue?vue&type=template&id=8dad9c12&scoped=true"
import script from "./traineeQuestions.vue?vue&type=script&lang=js"
export * from "./traineeQuestions.vue?vue&type=script&lang=js"
import style0 from "./traineeQuestions.vue?vue&type=style&index=0&id=8dad9c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dad9c12",
  null
  
)

export default component.exports